import { Modal, TimePicker } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { AiFillRightCircle, AiFillLeftCircle } from "react-icons/ai";
import styled from "styled-components";
import Checkbox from "../../../../Components/Checkbox/Checkbox";
import Heading from "../../../../Components/Headings/MainHeading/Heading";
import SubHeading from "../../../../Components/Headings/SubHeading/Heading";
import SingleShift from "./SingleShift";

export default function ShiftModal({
  date,
  setDate,
  modal,
  setModal,
  getFilteredShifts,
  allShifts,
  createShift,
  updateShift,
}) {
  const [getShiftDateFormat, setShiftDateFormat] = useState(date);
  const [shifts, setShifts] = useState([
    {
      name: "First Shift",
      orders: [1, 2, 3],
      drivers: [{ name: "Driver1" }, { name: "Driver2" }, { name: "Driver3" }],
      is_active: true,
    },
    {
      name: "Second Shift",
      orders: [],
      drivers: [{ name: "Driver1" }],
      is_active: true,
    },
    {
      name: "Third Shift",
      orders: [1, 2, 3],
      drivers: [
        { name: "Driver1" },
        { name: "Driver2" },
        { name: "Driver3" },
        { name: "Driver4" },
      ],
      is_active: false,
    },
  ]);

  useEffect(() => {
    setShifts(getFilteredShifts(moment(date).format("D")));
  }, [date, allShifts]);

  useEffect(() => {
    setShiftDateFormat(
      moment(date).format("LLLL").split(",")[0] +
        " " +
        moment(date).format("D/MM/YYYY")
    );
  }, [date]);

  const renderShiftDateFormat = () => {
    return <p className="date-format">{getShiftDateFormat}</p>;
  };

  const addDate = () => {
    setDate(moment(date).add(1, "days"));
  };

  const subsDate = () => {
    setDate(moment(date).subtract(1, "days"));
  };

  return (
    <div>
      <Modal
        visible={modal}
        className="lg"
        footer={false}
        onCancel={() => setModal(false)}
        width="80%"
      >
        <Wrapper>
          <div className="header-title">
            Editing timeframes for
            <button className="prev" onClick={subsDate}>
              <AiFillLeftCircle />
            </button>
            {renderShiftDateFormat()}
            <button className="next" onClick={addDate}>
              <AiFillRightCircle />
            </button>
          </div>
          <div className="body">
            {shifts.map((item) => {
              return (
                <>
                  <SingleShift
                    date={date}
                    single_shift={item}
                    updateShift={updateShift}
                  />
                </>
              );
            })}
            <div className="shift-card new">
              <div className="plus" onClick={createShift}>
                +
              </div>
            </div>
          </div>
        </Wrapper>
      </Modal>
    </div>
  );
}

const Wrapper = styled.div`
  .header-title {
    font-family: "Poppins";
    font-weight: 700;
    font-size: 18px;
    display: flex;
    .date-format {
      display: inline-block;
      color: var(--app-color-dark);
    }

    button {
      border: none;
      background-color: transparent;
      color: var(--color-light-gray);
      margin: 0px 5px;
      font-size: 26px;

      :hover {
        color: var(--app-color-dark);
      }
    }
    .prev {
      margin-left: 20px;
    }
  }

  .body {
    overflow-x: scroll;
    width: 100%;
    .shift-card {
      box-sizing: border-box;
      border: 0.5px solid #e8e8e8;
      border-radius: 8px;
      width: 23%;
      height: 80%;
      font-family: "Lato";
      padding: 10px;
      position: relative;
      min-height: 400px;
      margin-right: 10px;
      float: left;
      margin-bottom: 10px;
      .d-flex .shift-header {
        p {
          font-weight: 600;
          font-size: 17px;
          letter-spacing: -0.408px;
          color: #002733;
          .shift-order-len {
            font-size: 13px;
            color: var(--app-color-dark);
          }
        }
      }
      .continue {
        font-weight: 300;
        font-size: 17px;
        color: var(--app-color-dark);
      }

      .duration {
        margin-bottom: 5px;
        p {
          width: 20%;
          margin-top: 10px;
          color: var(--color-text-gray);
        }
        input {
          width: 80%;
          padding: 5px 10px;
          font-size: 18px;
          color: var(--color-dark);
          border-radius: 10px;
          border: 1px solid var(--color-light-gray);
          background-color: var(--color-light-gray-low);
          border: none;
          ::-webkit-calendar-picker-indicator {
            opacity: 0.5;
          }
        }
      }

      .couriers {
        width: 100%;
        display: flex;
        font-weight: bold;
        .title {
          width: 40%;
          float: left;
          p {
            padding: 0px;
            margin: 0px;
          }
          .light {
            color: var(--color-light-gray);
          }
        }

        .inputs {
          width: 40%;
          float: left;
          margin-top: 7px;
          p {
            margin: 0px 10px;
          }
          input {
            margin: 0px 10px;
            text-align: center;
            border: none;
            background: var(--color-light-gray-low);
            border-radius: 5px;
            max-width: 30px;
            height: 22px;
            padding: 0px;
            outline: none;
            font-weight: bold;

            /* Chrome, Safari, Edge, Opera */
            ::-webkit-outer-spin-button,
            ::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
          /* Firefox */
          input[type="number"] {
            -moz-appearance: textfield;
          }
          .curr {
          }
          .max {
            background-color: var(--color-light-gray-low);
            height: 25px;
            width: 25px;
            text-align: center;
            line-height: 2;
            vertical-align: middle;
            margin-top: -2px;
            border-radius: 2px;
          }
        }
        .empty {
          float: left;
          width: 20%;
        }
      }

      .drivers {
        font-weight: bold;
        height: 100px;
        overflow-y: scroll;
        ::-webkit-scrollbar {
          width: 0px;
          ::-webkit-scrollbar-thumb {
            background: #ff0000;
          }
        }
        .title {
          p {
            padding: 0px;
            margin: 0px;
          }
          .light {
            color: var(--color-light-gray);
          }
        }
      }

      .actions {
        /* position: absolute; */
        bottom: 0px;
        text-align: center;
        margin-top: 10px;
        /* margin-left: 20px; */
        .allow {
          display: flex;
          justify-content: center;
        }
        .status {
          color: var(--app-color-dark);
        }

        button {
          width: 100%;
          border: none;
          border-radius: 5px;
          font-weight: bold;
          font-size: 16px;
          padding: 5px 10px;
          margin-bottom: 10px;
        }
        .on {
          background: var(--color-light-gray);
          color: var(--color-text-gray);
        }
        .del {
          background: var(--color-text-danger);
          color: var(--color-light);
        }
        .off {
          background: var(--app-color-dark);
          color: var(--color-light);
        }
      }
    }
    .shift-card.new {
      box-sizing: inherit;
      border: none;
      position: relative;
      .plus {
        position: absolute;
        top: 30%;
        bottom: auto;
        font-size: 45px;
        height: 100px;
        width: 100px;
        background-color: var(--color-light-bg);
        color: white;
        text-align: center;
        line-height: 2;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
`;
